import firebase from 'firebase';
import firestore from 'firebase/firestore';

// Initialize Firebase
var config = {
  apiKey: 'AIzaSyA5wG7QN3pfOquH7IBfOwAW5d67JWeYrKA',
  authDomain: 'realtime-chatapp-65074.firebaseapp.com',
  databaseURL: 'https://realtime-chatapp-65074.firebaseio.com',
  projectId: 'realtime-chatapp-65074',
  storageBucket: 'realtime-chatapp-65074.appspot.com',
  messagingSenderId: '372280744713'
};
const firebaseApp = firebase.initializeApp(config);

firebaseApp.firestore().settings({ timestampsInSnapshots: true });

export default firebaseApp.firestore();



// WEBPACK FOOTER //
// ./src/firebase/init.js